function show_rose_alert(message, delay){
    if(!delay){
        delay = 4000;
    }
    $('#milano-alert span').html(message);
    $('#milano-alert').fadeIn(200);
    window.setTimeout(function(){
        $('#milano-alert').fadeOut(400);
    }, delay);
}
function reload_cart(){
    $.getJSON('/cart.js' , function(cart){
        var cart_items = cart.items ;
        var total_price = cart.total_price ;
        var total_price_formated = Shopify.formatMoney(total_price, theme.moneyFormat);
        var html = '' ;
        //var total_price_fomated = Shopify.formatMoney(total_price , moneyFormat );
        if (cart.items.length == 0 ) {
            var html = 'Your cart is currently empty.' ;
            $('.cart-modal-wrap tbody ').html(html) ;
            $('.cart-item-count').html(cart.item_count);
            var html_view_cart = '<i class="icon-cart"></i> View Cart ('+total_price_formated+')' ;    
          $('.view-cart.tool-nav-item').html(html_view_cart);
        }else{
           $.each(cart_items , function(i){
            var item_iamge = Shopify.resizeImage(cart_items[i].image, 'small');
            var item_url = cart_items[i].url ;
            var item_title = cart_items[i].title ;
            var item_quantity = cart_items[i].quantity ;
            var item_price = cart_items[i].price ;
            var item_id = cart_items[i].id ;
            var item_price_formated = Shopify.formatMoney(item_price, theme.moneyFormat);
            
            html += '<tr data-id='+item_id+'>'
                +'<td>'
                  +'<a href="#"><i class="cancel icon-cross btn-remove2"></i></a>'
                +'</td>'
                +'<td><a href="'+item_url+'"><img src="'+item_iamge+'" width="70" height="70" alt="'+item_title+'"></a></td>'
                +'<td><span><a href="'+item_url+'">'+item_title+'</a></span></td>'
                +'<td><span>'+item_quantity+'</span></td>'
                +'<td><span>'+item_price_formated+'</span></td>'
              +'</tr>' ;
        });
        html += '<tr>'
                +'<td> </td>'
                +'<td> </td>'
                +'<td><span>TOTAL</span></td>'
                +'<td> </td>'
                +'<td><span>'+total_price_formated+'</span></td>'
              +'</tr>'
        var html_view_cart = '<i class="icon-cart"></i> View Cart ('+total_price_formated+')' ;      
        $('.cart-modal-wrap tbody ').html(html) ;
        $('.cart-item-count').html(cart.item_count);
        $('.view-cart.tool-nav-item').html(html_view_cart);
        }

      
        
    });

}

function check_product_cookies(){
    var products = $.cookie('recent_products');
    console.log(products);
}

 // Update Cart Subtotal / Total
// ---------------------------------------------------------------------------------------
function update_price(tr){
    var qty = tr.find('.qty').val();
    var price = tr.find('.cart-item-price').data('price');
    var item_total_price = tr.find('.cart-item-total-price');
    value = Shopify.formatMoney( qty*price , theme.moneyFormat );
    item_total_price.html('<span>'+ value + '</span>');

}
function checkUrlHash() {
    var hash = window.location.hash;
    // Allow deep linking to recover password form
    if (hash === '#recover') {
      $("#customer-login").addClass("display");
      $("#forgot_password").removeClass("display");
    }
  }

jQuery(document).ready(function(){
    // prevent empty links
    // ---------------------------------------------------------------------------------------
    $('a[href=\\#]').on("click", function (event) {
        event.preventDefault();
    });

    // Update Cart Subtotal / Total
    // ---------------------------------------------------------------------------------------
    $('.alo_qty_des').on('click', function(){
       var input_el = $(this).parents('td').find('input');
       var val  = parseInt(input_el.val());
       var tr = $(this).parents('tr');
       if(val > 1 ){
          input_el.val(val-1);
       }
       update_price(tr);
    })
    $('.alo_qty_inc').on('click', function(){
        var input_el = $(this).parents('td').find('input');
       var val  = parseInt(input_el.val());
       var tr = $(this).parents('tr');
       input_el.val(val+1);
       update_price(tr);
    })
    $('.shopping-cart input.qty').on('change', function(){
      var tr = $(this).parents('tr'); 
      update_price(tr);
    })
    // Show/hide apply coupon code
    // ---------------------------------------------------------------------------------------
    $('.btn_apply_coupon').on('click', function(){
      if($('.input_apply_coupon').is(":visible")){
        $('.input_apply_coupon').fadeOut(500);
        $('.input_apply_coupon').val('');
      }else{
        $('.input_apply_coupon').fadeIn(500);
        $('.input_apply_coupon').focus();
      }
      
    })
  $('.owl-carousel#gal_01').owlCarousel({
      autoplay: false,
      loop: true,
      margin: 10,
      dots: false,
      items: 4,
      nav: true,
      navText:[
          "<i class='icon-arrow-left5'></i>",
          "<i class='icon-arrow-right5'></i>"
      ],
      responsiveClass:true,
      responsive: {
          0: {items: 3, nav:true},
          479: {items: 3, nav:true},
          768: {items: 3, nav:true},
          991: {items: 4, nav:true},
          1024: {items: 4, nav:true}
      }
    });
	$('.btn-quick-add-to-cart').on('click', function(){
	    var variant_id = $(this).parents('.product').attr('data-variant');
	    var qty = 1;
	    Shopify.addItem(variant_id, qty, function(){
            reload_cart();
	        var message = 'Item added to your cart';
	        show_rose_alert(message, 2000);
            
	    });
	   // window.setTimeout(update_mini_cart, 1000);

	})
	$(document).on('click', '.btn-remove2', function(){
        var variant_id = $(this).parents('tr').attr('data-id');
        Shopify.removeItem(variant_id, reload_cart );
        
  })

  // Resize Carousel Brands
  if($('.brand-list-carousel img').length ){
      var img_height = $('.brand-list-carousel img')[0].height;
      if($('.brand-list-carousel svg').length ){
      $.each($('.brand-list-carousel svg'), function(){
          $(this).css('height',img_height)
      })
    }
  }else{
      $.each($('.brand-list-carousel svg'), function(){
          $(this).css('height',133)
      })
    }
    
  // Save recent viewed products to cookie
  $.cookie.json = true;
  //Customer sections
  
  $("#customer-forgot-pw").click(function() {
      $("#customer-login").addClass("display");
      $("#forgot_password").removeClass("display");
  });
   $(".btn-cancel").click(function(){
      $("#customer-login").removeClass("display");
      $("#forgot_password").addClass("display");
  });
  checkUrlHash();
  //check for Recover password URL

  //Show/hide add address form
  $('.address-new-toggle').click(function(){
    $('#AddressNewForm').fadeIn(400);
  })
  $('.address_edit_open').click(function(){
    var form_id = $(this).attr('data-form-id');

    $('#EditAddress_'+form_id).fadeIn(400);
  })
  $('.newAddressClose').click(function(){
    $('#AddressNewForm').fadeOut(400);
  })
  $('.address_edit_close').click(function(){
    var form_id = $(this).attr('data-form-id');
    $('#EditAddress_'+form_id).fadeOut(400);
  })
  //Show/hide add address form

  $('#AddressCountryNew').on('change', function(){
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  })


  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');

    // eslint-disable-next-line no-alert
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})
 
